export default {
  meta: {
    title: '展位编辑'
  }
};
